import axios from "axios";

export const deleteProfileData = async (id?: string) => {
    return await axios.delete(`api/profiles/${id}/data`);
}